import { render } from "./PlayersListDraftPlayer.vue?vue&type=template&id=c5911068&scoped=true"
import script from "./PlayersListDraftPlayer.vue?vue&type=script&lang=js"
export * from "./PlayersListDraftPlayer.vue?vue&type=script&lang=js"

import "./PlayersListDraftPlayer.vue?vue&type=style&index=0&id=c5911068&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5911068"]])

export default __exports__